import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, LoadingController } from '@ionic/angular';
import { from, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthGuard } from '../guards/auth.guard';
import { EchoService } from './echo.service';
import { PagesPage } from 'src/app/pages/pages.page';
import { StorageService } from '../services/storage.service';
import { getPersistedLocale } from '../../i18n/i18n.config';

@Injectable()
export class Interceptor implements HttpInterceptor {

    loader: Promise<HTMLIonLoadingElement> | undefined;

    constructor(private storage: StorageService,
        private auth: AuthGuard,
        private router: Router,
        private alertController: AlertController,
        private loadingController: LoadingController,
        private echo: EchoService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const showError = !request.headers.has('showError') || request.headers.get('showError') !== 'false';
        request = request.clone({headers: request.headers.delete('showError')});

        if (!request.headers.has('Content-Type') && !(request.body instanceof FormData)) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        if (request.url.startsWith(environment.url)) {
            request = request.clone({
                headers: request.headers.set('X-App-Locale', getPersistedLocale())
            });
        }

        //REMOVER NULLS
        if(request.method === 'GET'){
            request.params.keys().forEach((k) => {
                if(request.params.get(k) == 'null'){
                    request = request.clone({params: request.params.delete(k)});
                }
            });
        }

        // if(request.method === 'GET'){
        //     const data: any = {};

        //     request.params.keys().forEach((k) => {
        //         if(request.params.getAll(k)){
        //             data[k] = request.params.getAll(k);
        //         }else{
        //             data[k] = request.params.get(k);
        //         }
        //     });

        //     request = request.clone({params : this.getParams(data)});
        // }

        return from(this.storage.get('user'))
            .pipe(
                switchMap((token) => {

                    if (token) {
                        request = request.clone({ headers: request.headers.set('Authorization', token.token_type + ' ' + token.access_token) });
                    }else{
                        if(this.auth.token){
                            request = request.clone({ headers: request.headers.set('Authorization', this.auth.token.token_type + ' ' + this.auth.token.access_token) });
                        }
                    }

                    if(this.echo.getSocketId()){
                        request = request.clone({ headers: request.headers.set('X-Socket-ID', this.echo.getSocketId()) });
                    }

                    //Envia a edificação que está usando
                    if(this.auth.usuario?.cliente?.modular){
                        request = request.clone({ headers: request.headers.set('Edificacao', this.auth.usuario?.edificacao?.id as string) });
                    }

                    return from(this.showLoader(request.headers.get('showLoader') as string)).pipe(
                        switchMap((loader) => {
                            if (!request.headers.has('showLoader') || (request.headers.has('showLoader') && request.headers.get('showLoader') !== 'false')) {
                                loader.present();
                            }

                            return next.handle(request).pipe(
                                map((event: HttpEvent<any>) => {
                                    if (event instanceof HttpResponse) {
                                        if (!request.headers.has('hideLoader') || (request.headers.has('hideLoader') && request.headers.get('hideLoader') === 'true')) {
                                            loader.dismiss();
                                            this.loader = undefined;
                                        }
                                    }
                                    return event;
                                }),
                                catchError((reject: HttpErrorResponse) => {
                                    loader.dismiss();
                                    this.loader = undefined;

                                    switch (reject.status) {
                                        case 0:
                                            break;
                                        case 400:
                                            if (reject.error.error === 'password_recently_changed') {
                                                this.presentAlert(reject.error.message || 'Sua senha foi alterada recentemente. Use a senha atual ou recupere seu acesso.', undefined, showError);
                                            } else if (reject.error.error === 'invalid_grant') {
                                                this.presentAlert('Login inválido, verifique seu usuário e senha.', undefined, showError);
                                            } else {
                                                this.presentAlert(reject.error.message, undefined, showError);
                                            }
                                            break;
                                        case 401:
                                            if (environment.production) {
                                                this.auth.clear();
                                            }
                                            this.storage.get('session').then((s) => {
                                                if(s){
                                                    this.storage.del('session');
                                                    this.storage.set('user', s.token).then(() => {
                                                        // location.reload();
                                                        this.auth.getUsuario().subscribe(() => {
                                                            this.router.navigate(['/']) ;
                                                            PagesPage.session.next(false);
                                                        });
                                                    });
                                                }else{
                                                    this.presentAlert('Autenticação inválida', undefined, showError);
                                                }
                                            })
                                            break;
                                        case 402:
                                            this.presentAlert('Para continuar a usar essa ferramenta você precisa adquirir uma licença.', 'Assinatura Requerida', showError);
                                            this.router.navigate(['assinar']);
                                            break;
                                        case 403:
                                            if(reject.error.error == 'expired')
                                                this.router.navigate(['/assinatura']);
                                            else if(reject.error.error == 'blocked')
                                                this.router.navigate(['/bloqueado']);
                                            else{
                                                this.presentAlert('Você não tem autorização para executar essa operação.', reject.error.message, showError);
                                            }
                                            break;
                                        case 404:
                                            //Pode ser um modelo não encontrado então simplesmente não mostra nada
                                            break;
                                        case 422:
                                            let sub: string | undefined = 'Dados inválidos!';
                                            let mensagem = '';
                                            if(reject.error.error){
                                                sub = undefined;
                                                mensagem = reject.error.error;
                                            }else if(reject.error?.errors){
                                                Object.keys(reject.error.errors).forEach((key) => {
                                                    mensagem = reject.error.errors[key][0];
                                                });
                                            }else{
                                                sub = undefined;
                                                mensagem = reject.error?.message || 'Dados inválidos!';
                                            }
                                            this.presentAlert(mensagem, sub, showError);
                                            break;
                                        case 429:
                                            this.presentAlert("Aguarde um momento e tente novamente", "Muitas requisições", showError);
                                            break;
                                        case 503:
                                            this.presentAlert("Volte novamente mais tarde", "Em Manutenção", showError);
                                            break;
                                        case 500:
                                        default:
                                            this.presentAlert('Ocorreu um erro, tente novamente mais tarde.', undefined, showError);
                                    }

                                    console.log(reject);

                                    return throwError(reject);
                                })
                            );
                        })
                    );
                })
            );
    }

    async presentAlert(mensagem: string, sub: string | undefined = 'não foi possível completar a requisição', showError = true) {
        if(showError){
            const alert = await this.alertController.create({
                header: 'Ops!',
                subHeader: sub,
                message: mensagem,
                buttons: [
                    //{cssClass : 'alert-button-cancel', text: 'Cancelar'},
                    'OK'
                ]
            });

            await alert.present();
        }
    }

    showLoader(message: string = 'Aguarde ...'): Promise<HTMLIonLoadingElement> {
        if(!this.loader){
            this.loader = this.loadingController.create({
                cssClass: 'app-loader',
                message: message != 'false' && message ? message : 'Aguarde ...',
            });
        }

        return this.loader;
    }

    private getParams(query: any) {
        let params: HttpParams = new HttpParams();
        for (const key of Object.keys(query)) {
            if (query[key] !== null && query[key] !== undefined) {
                if (query[key] instanceof Array) {
                    query[key].forEach((item: any) => {
                        params = params.append(`${key.toString()}[]`, item);
                    });
                } else {
                    params = params.append(key.toString(), query[key]);
                }
            }
        }

        return params;
    }
}
